import {
  Box,
  Stack,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Menu,
  MenuItem,
  Chip,
  Grid,
} from "@mui/material";
import React, { useState } from "react";
import FilterListIcon from "@mui/icons-material/FilterList";
import {
  blackShade19,
  blackShade44,
  borderTextBoxColor,
  greyColor060,
  greyColor061,
  greyColor42,
  greyColor53,
  greyColor56,
  perpleShade1,
  perpleShade2,
  perpleShade3,
  whiteColor,
} from "../../../configs/styles/muiThemes";
import moment from "moment";
import SaleChartSection from "./SaleChartSection";
import OrderChartSection from "./OrderChartSection";
import { useRef } from "react";
import OrderSummaryFilterCard from "../Cards/OrderSummaryFilterCard";
import CancelIcon from "@mui/icons-material/Cancel";
import { useSelector } from "react-redux";
import ThreeDotLoader from "../../../components/ThreeDotLoader";
import OrderAnalysisEmptyCard from "../Cards/OrderAnalysisEmptyCard";

function OrderSaleTableSection({ data, handleFilter, handleClearFilter }) {
  const [showFilter, setShowFilter] = useState(false);
  const [selectedSearch, setSelectedSearch] = useState(null);
  const [searchApplied, setSelectedApplied] = useState(null);
  const [error, setError] = useState("");

  const orderSummaryFilterRef = useRef(null);

  const { orderSaleAmtTableMonthDataLoader } = useSelector(
    (state) => state.orderSummary
  );

  const handleClick = (event) => {
    setShowFilter(true);
    // setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setShowFilter(false);
    // setAnchorEl(null);
  };

  const handleSelect = () => {
    setError(null);
    if (!selectedSearch) {
      setError("Select the filter");
      return;
    }
    // setSelectedYear(year);
    handleFilter(selectedSearch);
    handleClose();
    setSelectedApplied(selectedSearch);
  };
  const clearFilter = () => {
    setSelectedApplied(null);
    setError(null);
    setSelectedSearch(null);
    // setSelectedYear("");
    handleClearFilter();
  };
  return (
    <Stack
      mt={2}
      gap={"10px"}
      sx={{
        border: "1px solid " + greyColor56,
        borderRadius: "10px",
        backgroundColor: "rgb(248, 249, 250)",
        p: "8px 15px 15px",
      }}
    >
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Typography
          fontSize={13.5}
          fontWeight={600}
          color={blackShade19}
          lineHeight="20px"
        >
          Orders & Sales Analysis
        </Typography>
        <Box display="flex" gap="10px">
          {searchApplied && (
            <Box
              position="relative"
              sx={{
                backgroundColor: perpleShade1,
                border: "1px solid" + perpleShade3,
                p: "4px 10px",
                borderRadius: "5px",
              }}
            >
              <Box
                // component={Button}
                sx={{
                  cursor: "pointer",
                  position: "absolute",
                  right: "-7px",
                  top: "-11px",
                }}
                onClick={clearFilter}
              >
                <CancelIcon
                  sx={{
                    fontSize: "17px",
                    color: perpleShade2,
                  }}
                />
              </Box>
              <Typography
                sx={{
                  fontSize: 12,
                  fontWeight: 500,
                  color: perpleShade2,
                  lineHeight: 1.5,
                }}
              >
                Orders & Sales Analysis By :{" "}
                {searchApplied?.type === "year"
                  ? searchApplied?.year
                  : searchApplied?.dateRange}
              </Typography>
            </Box>
          )}
          <Box position="relative" ref={orderSummaryFilterRef}>
            <Button
              variant="contained"
              disableElevation
              endIcon={<FilterListIcon sx={{ fontSize: 17 }} />}
              sx={styles.filterBtn}
              onClick={handleClick}
            >
              Filter
            </Button>
            {showFilter && (
              <OrderSummaryFilterCard
                onCancel={handleClose}
                selectedSearch={selectedSearch}
                setSelectedSearch={setSelectedSearch}
                handleApply={handleSelect}
                error={error}
              />
            )}
          </Box>

          {/* <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleClose}
          >
            {years.map((year) => (
              <MenuItem key={year} onClick={() => handleSelect(year)}>
                {year}
              </MenuItem>
            ))}
          </Menu> */}
        </Box>
      </Box>
      {!orderSaleAmtTableMonthDataLoader ? (
        data?.length > 0 ? (
          <>
            <Box sx={styles.tableWrapper}>
              <TableContainer sx={styles.tableContainer} component={Box}>
                <Table>
                  <TableHead>
                    <TableRow
                      sx={{
                        position: "sticky !important",
                        top: 0,
                        backgroundColor: greyColor42,
                        zIndex: 8,
                        borderRadius: "8px 8px 0 0",
                      }}
                    >
                      {data.map((item) => (
                        <TableCell
                          key={item.month}
                          sx={styles.tableCell}
                          align="center"
                        >
                          {item.month}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody sx={{ backgroundColor: whiteColor }}>
                    <TableRow
                      sx={{
                        borderBottom: `1px solid ${borderTextBoxColor}`,
                        verticalAlign: "top",
                        px: "12px",
                      }}
                    >
                      {data.map((item) => (
                        <TableCell
                          key={item.month + "-value"}
                          align="center"
                          sx={styles.tableBodyCell}
                        >
                          {item.orderCount || "-"}
                        </TableCell>
                      ))}
                    </TableRow>
                    <TableRow>
                      {data.map((item) => (
                        <TableCell
                          key={item.month + "-amount"}
                          align="center"
                          sx={styles.tableBodyCell}
                        >
                          {item.totalSales || "-"}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>

            <Grid container columnSpacing={4} mt={"10px"}>
              <Grid item xs={12} md={6}>
                {data && <SaleChartSection chartData={data} />}
              </Grid>

              {/* Order Analysis Graph */}
              <Grid item xs={12} md={6}>
                <OrderChartSection chartData={data} />
              </Grid>
            </Grid>
          </>
        ) : (
          <OrderAnalysisEmptyCard />
        )
      ) : (
        <ThreeDotLoader />
      )}
    </Stack>
  );
}

export default OrderSaleTableSection;

const styles = {
  filterBtn: {
    border: "1px solid " + greyColor061,
    color: blackShade44,
    borderRadius: "6px",
    backgroundColor: whiteColor,
    fontSize: "11.5px",
    fontWeight: 600,
    p: "5px 18px",
    "&:hover": {
      color: blackShade44,
      borderRadius: "6px",
      backgroundColor: whiteColor,
    },
  },
  tableWrapper: {
    // width: "100%",
    width: 'calc(100vw - 350px)',
    borderRadius: "8px",
    border: `1px solid ${borderTextBoxColor}`,
    borderBottom: "none",
    overflow: "hidden",
  },

  tableContainer: {
    borderRadius: "8px",
    maxWidth: "100%",
  },

  tableCell: {
    color: greyColor060,
    fontSize: "12px",
    fontWeight: "400",
    lineHeight: "16px",
    whiteSpace: "nowrap",
    padding: "8px 15px",
    backgroundColor: greyColor53,
    textAlign: "start",
    // borderRight: `1px solid ${whiteColor}`,
  },

  tableBodyCell: {
    fontSize: 12,
    fontWeight: 600,
    lineHeight: "16px",
    whiteSpace: "nowrap",
    color: blackShade19,
    padding: "10px 15px !important",
    textAlign: "start",
  },
};
